export enum ButtonColorScheme {
    Orange = 'orange',
    Teal = 'teal',
    Transparent = 'transparent',
    White = 'white',
}
